import { createI18n } from 'vue-i18n'
import { LanguageEnum } from '@/generated/graphql.mia'
import { defaultLanguage, useCustomParams } from '@/composables/useCustomParams'

const getLocale = () => {
  const { language } = useCustomParams()

  return Object.values(LanguageEnum).some(l => l.toLocaleLowerCase() === language.toLocaleLowerCase())
    ? language
    : defaultLanguage
}

const i18n = createI18n({
  locale: getLocale(),
  legacy: false,
  globalInjection: true,
  messages: {}
})

export default i18n
